var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _vm.employee
        ? _c(
            "v-dialog",
            {
              attrs: { lazy: "", "max-width": "600" },
              on: {
                input: function(v) {
                  return v || _vm.restoreEmployeeForm()
                }
              },
              model: {
                value: _vm.employee,
                callback: function($$v) {
                  _vm.employee = $$v
                },
                expression: "employee"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("span", { staticClass: "title pb-2" }, [
                        _vm._v(
                          "Edit Employee: " + _vm._s(_vm.employee.userName)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "span",
                            { staticClass: "mt-2 subheadline accent--text" },
                            [_vm._v("Permissions")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "pl-3",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  _vm.openPermissionsHelp = true
                                }
                              }
                            },
                            [_vm._v("help")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: { label: "Admin", value: "PERM_ADMIN" },
                                model: {
                                  value: _vm.employee.companyPermissions,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.employee,
                                      "companyPermissions",
                                      $$v
                                    )
                                  },
                                  expression: "employee.companyPermissions"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Receiving",
                                  value: "PERM_RECEIVING"
                                },
                                model: {
                                  value: _vm.employee.companyPermissions,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.employee,
                                      "companyPermissions",
                                      $$v
                                    )
                                  },
                                  expression: "employee.companyPermissions"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Financial",
                                  value: "PERM_FINANCIAL"
                                },
                                model: {
                                  value: _vm.employee.companyPermissions,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.employee,
                                      "companyPermissions",
                                      $$v
                                    )
                                  },
                                  expression: "employee.companyPermissions"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Office",
                                  value: "PERM_OFFICE"
                                },
                                model: {
                                  value: _vm.employee.companyPermissions,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.employee,
                                      "companyPermissions",
                                      $$v
                                    )
                                  },
                                  expression: "employee.companyPermissions"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { sm6: "" } }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Dispatched Driver",
                                  value: "PERM_DRIVER"
                                },
                                model: {
                                  value: _vm.employee.companyPermissions,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.employee,
                                      "companyPermissions",
                                      $$v
                                    )
                                  },
                                  expression: "employee.companyPermissions"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _vm.isLtnAdmin
                                ? _c("v-checkbox", {
                                    attrs: {
                                      label: "Direct Assign",
                                      value: "PERM_LOAD_ASSIGN"
                                    },
                                    model: {
                                      value: _vm.employee.companyPermissions,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.employee,
                                          "companyPermissions",
                                          $$v
                                        )
                                      },
                                      expression: "employee.companyPermissions"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "accent" },
                              on: { click: _vm.saveEmployee }
                            },
                            [_vm._v("Save")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "accent", flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.employee = null
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          staticClass: "darken-1",
          attrs: { flat: "", dense: "", extended: "", color: "white" },
          scopedSlots: _vm._u([
            {
              key: "extension",
              fn: function() {
                return [
                  _c("v-text-field", {
                    staticClass: "mx-3",
                    attrs: {
                      "append-icon": "search",
                      placeholder: "Search for an employee"
                    },
                    model: {
                      value: _vm.searchTerm,
                      callback: function($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-spacer")
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("v-toolbar-title", [_vm._v("Team & Permissions")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "accent" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("add-new")
                    }
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("person_add_alt_1")
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Add to Team")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "pb-4", attrs: { flat: "" } },
        [
          _vm._l(_vm.company.employees, function(employee) {
            return _vm.$vuetify.breakpoint.smAndDown
              ? _c(
                  "v-card",
                  { key: employee.id, staticClass: "xs12 my-2" },
                  [
                    _c(
                      "v-card-title",
                      [
                        _c("v-layout", { attrs: { column: "" } }, [
                          _c("h6", { staticClass: "title" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(employee.userName) +
                                "\n                    "
                            ),
                            employee.userId === _vm.userProfile.id
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        (You)\n                    "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      [
                        _c("b", [_vm._v("Email:")]),
                        _vm._v(" " + _vm._s(employee.contactEmail)),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", [_vm._v("Permissions:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              employee.companyPermissions
                                ? employee.companyPermissions.join(", ")
                                : null
                            )
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", [_vm._v("CDL Expiration:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._.get(
                                employee,
                                "driverProfile.cdlExpires",
                                null
                              )
                            )
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", [_vm._v("Medical Endorsement Expiration: ")]),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._.get(
                                employee,
                                "driverProfile.medicalExpires",
                                null
                              )
                            )
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              [
                                _vm.isAdmin
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          flat: "",
                                          small: "",
                                          color: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.editEmployee(employee)
                                          }
                                        }
                                      },
                                      [_vm._v("Edit")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              [
                                _vm.isAdmin
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          flat: "",
                                          small: "",
                                          color: "accent"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeEmployee(
                                              employee.userId,
                                              employee.userName ||
                                                employee.contactEmail
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      Remove\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.smAndUp
            ? _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  "disable-initial-sort": "",
                  "item-key": "userId",
                  items: _vm.company.employees,
                  search: _vm.searchTerm
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "items",
                      fn: function(slotItems) {
                        return [
                          _c(
                            "td",
                            [
                              _c(
                                "v-toolbar-items",
                                { staticClass: "mx-0 px-0" },
                                [
                                  _vm.isAdmin
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            small: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.editEmployee(
                                                slotItems.item
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Edit")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            small: "",
                                            color: "accent"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeEmployee(
                                                slotItems.item.userId,
                                                slotItems.item.userName ||
                                                  slotItems.item.contactEmail
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Remove\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandRow(slotItems)
                                }
                              }
                            },
                            [
                              _c("v-layout", { attrs: { row: "" } }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(slotItems.item.userName) +
                                    "\n                    "
                                ),
                                slotItems.item.userId === _vm.userProfile.id
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                        (You)\n                    "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-action-text", [
                                _vm._v(_vm._s(slotItems.item.contactEmail))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandRow(slotItems)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    slotItems.item.companyPermissions
                                      ? slotItems.item.companyPermissions.join(
                                          ", "
                                        )
                                      : null
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandRow(slotItems)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._.get(
                                      slotItems,
                                      "item.driverProfile.cdlExpires",
                                      null
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandRow(slotItems)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._.get(
                                      slotItems,
                                      "item.driverProfile.medicalExpires",
                                      null
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", {
                            on: {
                              click: function($event) {
                                return _vm.expandRow(slotItems)
                              }
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "expand",
                      fn: function(slotItems) {
                        return _vm.isLtnAdmin
                          ? [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "text-capitalize",
                                          attrs: {
                                            flat: "",
                                            to: {
                                              name: "notification-settings",
                                              query: {
                                                userId: slotItems.item.userId
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Notifications Settings\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "text-capitalize",
                                          attrs: {
                                            flat: "",
                                            to: {
                                              name: "profile",
                                              params: {
                                                userId: slotItems.item.userId
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Profile\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("user-expand", {
                                attrs: { "user-id": slotItems.item.userId }
                              })
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a36a7e8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a36a7e8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/EmployeesSection.vue
// module id = null
// module chunks = 